import React from "react";
import { RangeSC, SliderButtonSC, SliderWrapperSC } from "./styled";

interface HorizontalSliderProps {
    value?: number;
    onValueChange?: (value: number) => void;
    width?: number;
    min?: number;
    max?: number;
    step?: number;
}

export const HorizontalSlider = ({
    value = 0,
    onValueChange,
    width = 80,
    min = 0,
    max = 99,
    step = 1,
}: HorizontalSliderProps) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newValue = Number(event.target.value);
        if (onValueChange) {
            onValueChange(newValue);
        }
    };

    const increment = () => {
        if (onValueChange) {
            onValueChange(Math.min((value ?? 0) + step, max));
        }
    };

    const decrement = () => {
        if (onValueChange) {
            onValueChange(Math.max((value ?? 0) - step, min));
        }
    };

    return (
        <SliderWrapperSC>
            <SliderButtonSC type="button" onClick={decrement} className="slider-button">
                –
            </SliderButtonSC>

            <RangeSC
                type="range"
                min={min}
                max={max}
                value={value}
                step={step}
                onChange={handleChange}
                style={{ width }}
            />
            <SliderButtonSC type="button" onClick={increment} className="slider-button">
                +
            </SliderButtonSC>
        </SliderWrapperSC>
    );
};
